import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface CalloutDescriptionProps extends TypographyProps {}

const CalloutDescription: FC<CalloutDescriptionProps> = ({ children, ...props }) => {
    return (
        <Typography variant="body2" color="text.secondary" {...props}>
            {children}
        </Typography>
    );
};

export type { CalloutDescriptionProps };
export default CalloutDescription;
